import { render } from "./ClientListing.vue?vue&type=template&id=8d44bb36&scoped=true"
import script from "./ClientListing.vue?vue&type=script&lang=js"
export * from "./ClientListing.vue?vue&type=script&lang=js"

import "./ClientListing.vue?vue&type=style&index=0&id=8d44bb36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d44bb36"],['__file',"src/components/client/ClientListing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8d44bb36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d44bb36', __exports__)) {
    api.reload('8d44bb36', __exports__)
  }
  
  module.hot.accept("./ClientListing.vue?vue&type=template&id=8d44bb36&scoped=true", () => {
    api.rerender('8d44bb36', render)
  })

}


export default __exports__